module.exports = __webpack_public_path__ + "img/teacher.71068730.svg";